import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { SelectionItem } from '@shared/models';
import { StaticMessage } from '@shared/enums';
import cloneDeep from 'lodash.clonedeep';

@Component({
  selector: 'app-multiselect',
  templateUrl: './multiselect.component.html',
  styleUrls: ['./multiselect.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiselectComponent implements OnInit {
  @Input({ required: true }) options: SelectionItem[];
  @Input({ required: true }) data: (number | string)[];
  @Input({ required: true }) selectLabel: string;
  @Input({ required: true }) canEdit: boolean;
  @Input() isDisabled: boolean;
  @Input() panelClass: string;
  @Output() selectionChanged = new EventEmitter<(number | string)[]>();

  @ViewChild(MatSelect)
  private multiselectComponent: MatSelect;

  StaticMessage = StaticMessage;
  defaultSelectLabel = $localize`:@@shared.multiselect.lblSelectLabel:Select value`;

  selectedData = [];
  userSelectedData = [];

  ngOnInit(): void {
    this.selectedData = cloneDeep(
      (this.data ?? []).map(
        (x) => this.options.find((y) => y.id === x)?.name
      ) ?? []
    ).filter((x) => x);

    this.userSelectedData = [...this.selectedData];
  }

  onApply(): void {
    this.applySelection();

    this.multiselectComponent.toggle();
  }

  onCancel(): void {
    this.multiselectComponent.toggle();
    this.userSelectedData = [...this.selectedData];
  }

  onClear(): void {
    this.userSelectedData = [];
  }

  openedChange(opened: boolean): void {
    if (!opened) {
      this.userSelectedData = [...this.selectedData];
    }
  }

  private applySelection(): void {
    this.selectedData = this.userSelectedData;
    this.selectionChanged.emit(
      this.selectedData.map((x) => this.options.find((y) => y.name === x)?.id)
    );
  }
}
